import { IKnmDataViolation } from 'APIPackage/KnmModule/interfaces/IKnmDataViolation';

export const convertKnmViolationToExtended = (knmViolation: IKnmDataViolation) => {
  const pathSplit = knmViolation.path.split('/');
  let containerId = null;

  if (
    pathSplit.length > 3 &&
    (pathSplit[2] === 'events' ||
      pathSplit[2] === 'inspectors' ||
      pathSplit[2] === 'legalBases' ||
      pathSplit[2] === 'requirements')
  ) {
    containerId = `${pathSplit[3]}`;
    pathSplit[3] = '{guid}';
  } else if (pathSplit.length > 3 && pathSplit[2] === 'objects') {
    containerId = `${pathSplit[3]}`;
    pathSplit[3] = '{guid}';
    if (pathSplit.length > 5 && (pathSplit[4] === 'checklists' || pathSplit[4] === 'supervisions')) {
      containerId = `${pathSplit[5]}`;
      pathSplit[5] = '{guid}';
    } else if (pathSplit.length > 5 && pathSplit[4] === 'result') {
      pathSplit[5] = '{guid}';
      if (
        pathSplit.length > 7 &&
        (pathSplit[6] === 'additionalInfo' ||
          pathSplit[6] === 'delegates' ||
          pathSplit[6] === 'inspectors' ||
          pathSplit[6] === 'violations')
      ) {
        pathSplit[7] = '{guid}';
        if (pathSplit.length > 9 && pathSplit[8] === 'lawsuits') {
          pathSplit[9] = '{guid}';
        }
      }
    }
  } else if (pathSplit[2] === 'knoOrganization' && pathSplit[3] === 'functions' && pathSplit.length > 4) {
    containerId = `${pathSplit[4]}`;
    pathSplit[4] = '{guid}';
  }

  return {
    ...knmViolation,
    containerId,
    pathTemplate: pathSplit.join('/'),
  };
};
